export class CommonOrderModel {
  orderReference: string;
}
